import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import MultiColumnComboBoxProps from './MultiColumnComboBoxProps'

import KendoMultiColumnComboBoxColumn from './KendoMultiColumnComboBoxColumn'
import Animation from '../Common/Animation'
import Popup from '../Common/Popup'
import Virtual from '../Common/Virtual'

export default {
    render(createElement) {
        return createElement('input', [
            this.$slots['kendo-datasource'],
            this.$slots['default']
        ])
    },
    props: MultiColumnComboBoxProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Popup,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el
        that._resolveChildren()
        kendo.jQuery(this.$el).kendoMultiColumnComboBox(this.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', widgetElement.value)
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el
            return kendo.jQuery(widgetElement).getKendoMultiColumnComboBox()
        },
        _resolveChildren () {
            this.resolveChildren('columns', KendoMultiColumnComboBoxColumn.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/KendoMultiColumnComboBoxMixin.js